import React from 'react';

const HideValidationPopupsContext = React.createContext(false);

export default HideValidationPopupsContext;
